import { render, staticRenderFns } from "./RegisterDeodorizerController.vue?vue&type=template&id=0c8a0be4&scoped=true"
import script from "./RegisterDeodorizerController.vue?vue&type=script&lang=js"
export * from "./RegisterDeodorizerController.vue?vue&type=script&lang=js"
import style0 from "./RegisterDeodorizerController.vue?vue&type=style&index=0&id=0c8a0be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a0be4",
  null
  
)

export default component.exports